import styled from 'styled-components/macro';

export const IndustriukaLogoSvg = () => {
    return (
        <S_SVG
            xmlns="http://www.w3.org/2000/svg"
            width="379.726"
            height="42.662"
            viewBox="0 0 379.726 42.662"
        >
            <defs>
                <clipPath id="clip-path">
                    <rect
                        id="Rectangle_67"
                        data-name="Rectangle 67"
                        width="379.726"
                        height="42.662"
                        fill="none"
                    />
                </clipPath>
            </defs>
            <g id="Group_32" data-name="Group 32" transform="translate(0 0)">
                <rect
                    id="Rectangle_65"
                    data-name="Rectangle 65"
                    width="8.437"
                    height="41.58"
                    transform="translate(0 0.543)"
                    fill="#fff"
                />
                <path
                    id="Path_4"
                    data-name="Path 4"
                    d="M29.2.187V26.278L12.933.187H5.944l0,41.577h8.016V16.034L30.166,41.765h7.05V.187Z"
                    transform="translate(11.295 0.356)"
                    fill="#fff"
                />
                <g id="Group_31" data-name="Group 31" transform="translate(0 0)">
                    <g id="Group_30" data-name="Group 30" clipPath="url(#clip-path)">
                        <path
                            id="Path_5"
                            data-name="Path 5"
                            d="M41.864,23.687V18.264c0-7.172-1.929-10.909-7.532-10.909H28v27.3h6.328c5.6,0,7.532-3.795,7.532-10.967m-22.3,18.077V.187H34.332c9.4,0,15.968,4.819,15.968,18.077v5.422c0,13.2-6.568,18.077-15.968,18.077Z"
                            transform="translate(37.203 0.355)"
                            fill="#fff"
                        />
                        <path
                            id="Path_6"
                            data-name="Path 6"
                            d="M64.488.187V24.894c0,12.29-6.748,17.413-15.968,17.413S32.551,37.183,32.551,24.952V.187h8.437V24.952c0,7.111,2.35,10.244,7.532,10.244s7.532-3.133,7.532-10.244V.187Z"
                            transform="translate(61.886 0.355)"
                            fill="#fff"
                        />
                        <path
                            id="Path_7"
                            data-name="Path 7"
                            d="M69.321,11.329c-1.807-2.832-3.978-4.218-8.2-4.218-3.795,0-5.843,1.747-5.843,4.581,0,3.252,2.652,4.7,8.193,6.084,8.678,2.17,12.594,5.425,12.594,12.777,0,6.809-4.578,12.11-14.341,12.11-7.291,0-12.353-1.987-16.029-6.809l6.449-4.459c2.228,2.774,4.758,4.16,9.037,4.16,4.822,0,6.447-2.109,6.447-4.642,0-2.893-1.747-4.52-8.495-6.267-8.2-2.17-12.292-6.087-12.292-12.954C46.845,5.124,51.182,0,61.067,0c6.626,0,11.628,2.231,14.582,6.809Z"
                            transform="translate(86.884 -0.001)"
                            fill="#fff"
                        />
                        <path
                            id="Path_8"
                            data-name="Path 8"
                            d="M88.312.187V7.356H76.864V41.765H68.427V7.356H56.979V.187Z"
                            transform="translate(108.33 0.355)"
                            fill="#fff"
                        />
                        <path
                            id="Path_9"
                            data-name="Path 9"
                            d="M83.459,18.322c5,0,7.894-1.082,7.894-5.422s-2.893-5.544-7.894-5.544H77.793V18.322Zm8.556,23.442L84.544,25.433H77.793V41.764H69.359V.187H84.242c9.58,0,15.545,4.279,15.545,12.713,0,5.605-2.591,9.281-7.111,11.149l8.617,17.715Z"
                            transform="translate(131.866 0.355)"
                            fill="#fff"
                        />
                        <rect
                            id="Rectangle_66"
                            data-name="Rectangle 66"
                            width="8.437"
                            height="41.577"
                            transform="translate(239.011 0.543)"
                            fill="#fff"
                        />
                        <path
                            id="Path_10"
                            data-name="Path 10"
                            d="M99.75,16.469a5.252,5.252,0,0,1-1.567,3.859,5.65,5.65,0,0,1-7.8,0,5.2,5.2,0,0,1-1.6-3.859,5.355,5.355,0,0,1,1.6-3.946,5.562,5.562,0,0,1,7.8,0,5.408,5.408,0,0,1,1.567,3.946"
                            transform="translate(168.792 20.77)"
                            fill="#db5631"
                        />
                        <path
                            id="Path_11"
                            data-name="Path 11"
                            d="M94.8,24.772V.187h3.5V24.772c0,9.641,3.975,14.1,11.265,14.1s11.268-4.459,11.268-14.1V.187h3.5V24.772c0,12.232-5.724,17.355-14.764,17.355S94.8,37,94.8,24.772"
                            transform="translate(180.245 0.355)"
                            fill="#fff"
                        />
                        <path
                            id="Path_12"
                            data-name="Path 12"
                            d="M135.959,41.765l-15.3-22.174-8.437,10V41.765h-3.5V.187h3.5V24.349L132.523.187H137.1L123,16.817l17.172,24.948Z"
                            transform="translate(206.704 0.355)"
                            fill="#fff"
                        />
                        <path
                            id="Path_13"
                            data-name="Path 13"
                            d="M128.156,28.387h15.3l-7.653-22.6Zm-8.2,13.378L134.182.187h3.252l14.222,41.577H147.98l-3.435-10.122H127.071l-3.377,10.122Z"
                            transform="translate(228.07 0.355)"
                            fill="#fff"
                        />
                    </g>
                </g>
            </g>
        </S_SVG>
    );
};

const S_SVG = styled.svg`
    width: 200px;
    margin: 0 0 20px 0;
`;
